import { Component, OnInit, Input } from '@angular/core';
// import { AuthService, FacebookLoginProvider, SocialUser } from 'angularx-social-login';
import { AuthService, FacebookLoginProvider } from 'angular-6-social-login';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NavService } from 'src/app/providers/nav.service';
import { ApiService } from 'src/app/providers/api.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { auth } from 'firebase';
import { platformList, sportList } from 'src/app/shared.service';
import { CommonService } from 'src/app/providers/common.service';

// declare const gapi: any;
// import facebookLogin from 'facebook-login';
// import firebase from 'firebase';
// import { Http } from '@angular/http';
// import { HttpClient } from '@angular/common/http';

// const api = facebookLogin({ appId: '325973485413885' });

declare let FB: any;


@Component({
  selector: 'app-socialmediabuttons',
  templateUrl: './socialmediabuttons.component.html',
  styleUrls: ['./socialmediabuttons.component.css']
})
export class SocialmediabuttonsComponent implements OnInit {
  @Input()
  pageType: any;

  user: any = {};
  loggedIn: boolean;
  LoginType = '';

  // private sub: any;
  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private route: Router,
    private api: ApiService,
    // private http: Http,
    // private testhttp: HttpClient,
    public afAuth: AngularFireAuth,
    public afs: AngularFirestore,
    private navService: NavService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    // if (localStorage.getItem("loginDetails")) {
    if (localStorage.getItem('userDetails')) {
      this.loggedIn = true;
    }

    // this.authService.authState.subscribe((user) => {
    //   this.user = user;
    //   this.loggedIn = (user != null);
    //   console.log(this.user);
    // });


  }


  TwitterAuth() {

    // this.AuthLogin(new firebase.auth.TwitterAuthProvider());
    return this.AuthLogin(new auth.TwitterAuthProvider());

    // this.AuthLogin(new auth.TwitterAuthProvider());
    // this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);

  }

  signInWithFB() {
    return this.AuthLogin(new auth.FacebookAuthProvider());
  }

  // Auth logic to run auth providers
  AuthLogin(provider) {
    let isCalled = false;

    return this.afAuth.auth.signInWithPopup(provider)
      // this.afAuth.auth.signInWithPopup(provider)
      .then((result) => {
        // console.log('You have been successfully logged in!');
        // console.log(result);
        this.user = result;
        this.loggedIn = (result != null);
        if (this.loggedIn && localStorage.getItem('userDetails') == null && !isCalled) {
          isCalled = true;
          // console.log('User is looged in is ' + this.loggedIn);
          let fbDet: any = {};
          if (this.pageType == 'signInFB' || this.pageType == 'signUpFB') {
            fbDet = {
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              email: this.user.email,
              fullName: this.user.name,
              accessToken: this.user.token,
              isLogin: false,
              isSocialLogin: true,
              isSocialLoginType: 'FB',
              platformName: platformList[platformList.DraftKings],
              sportName: sportList[sportList.NFL],
              default_platform_id: platformList.DraftKings,
              default_sport_id: sportList.NFL
            };
            this.LoginType = 'FB';
          } else if (this.pageType == 'signInTwitter') {
            fbDet = {
              firstName: this.user.additionalUserInfo.profile.name,
              lastName: '',
              email: this.user.additionalUserInfo.profile.email,
              fullName: this.user.additionalUserInfo.profile.name,
              accessToken: this.user.credential.accessToken,
              isLogin: false,
              isSocialLogin: true,
              isSocialLoginType: 'Twitter',
              platformName: platformList[platformList.DraftKings],
              sportName: sportList[sportList.NFL],
              default_platform_id: platformList.DraftKings,
              default_sport_id: sportList.NFL
            };
            this.LoginType = 'Twitter';
          }
          this.commonService.platformandsport.sport_id = sportList.NFL;
          this.commonService.platformandsport.platform_id = platformList.DraftKings;
          localStorage.setItem('userDetails', JSON.stringify(fbDet));
          this.navService.changeNav('item');
          this.toastr.success('Login successfully', 'Success');
          this.route.navigate(['/DashBoard']);
        }

      }).catch((error) => {
        // console.log(error)
      });
  }



  signInWithFB1(): void {

    let isCalled = false;
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID).then(socialusers => {
      // console.log(socialusers);
      this.user = socialusers;
      this.loggedIn = (socialusers != null);
      if (this.loggedIn && localStorage.getItem('userDetails') == null && !isCalled) {
        isCalled = true;
        // console.log('User is looged in is ' + this.loggedIn);
        let fbDet: any = {};
        if (this.pageType == 'signIn' || this.pageType == 'signUp') {
          // console.log('signIn page');
          fbDet = {
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            fullName: this.user.name,
            accessToken: this.user.token,
            isLogin: false,
            isSocialLogin: true
          };
        }
        localStorage.setItem('userDetails', JSON.stringify(fbDet));
        this.navService.changeNav('item');
        this.toastr.success('Login successfully', 'Success');
        this.route.navigate(['/DashBoard']);
      }

    });
  }


  onCreateAccountWithFB(item) {
    const tempSignupDet: any = {};
    this.api.signUp(item).subscribe(data => {
      if (data && data.code == '100') {
        tempSignupDet.UserID = data.user_id;
        tempSignupDet.RegisterStatusCode = data.register_status_code;
        tempSignupDet.accessToken = data.accessToken;

        localStorage.setItem('userDetails', JSON.stringify(tempSignupDet));
        this.navService.changeNav('item');
        this.toastr.success(data.message, 'Success');
        this.route.navigate(['/DashBoard']);
      } else {
        this.toastr.warning(data.message, 'Major Error');
      }
    }, (err) => {
      this.toastr.error('something went wrong', 'Major Error');
    });
  }

  onNormalLogout() {
    localStorage.clear();
    this.navService.changeNav('');
  }

  onLogout() {

    this.afAuth.auth.signOut().then((item) => {
      // console.log('success :' + item)
    }).catch((ex) => {
      // console.log('Exception :' + ex)
    });

    localStorage.clear();
    this.navService.changeNav('');


    // const userData = JSON.parse(localStorage.getItem("userDetails"));
    // let data = {
    //   access_token: userData.accessToken
    // }

    // let url = 'https://api.twitter.com/oauth/authorize?force_login=true';
    // let url1 = 'https://api.twitter.com/oauth2/invalidate_token?access_token=' + userData.accessToken;
    // let headers = new Headers();
    // headers.append('authorization', 'OAuth');
    // headers.append('oauth_token', userData.accessToken);
    // headers.append('oauth_consumer_key', "AIzaSyC29BQs5JI6S2wQQ4ZvENIUhGZPwmR2d5U");
    // headers.append('oauth_nonce', "AUTO_GENERATED_NONCE");
    // headers.append('oauth_signature', "AUTO_GENERATED_SIGNATURE");
    // headers.append('oauth_signature_method', "HMAC");
    // headers.append('oauth_timestamp', "AUTO_GENERATED_TIMESTAMP");
    // headers.append('oauth_version', "1.0");

    // this.http.post(url1,data, {
    //   headers: headers
    // }).subscribe(item => {
    //   console.log(item);
    //   // localStorage.clear();
    //   // this.navService.changeNav('');

    // },(err) => {
    //   console.log("Twitter apis Error :" + err);
    // });

    // var _self = this;
    // var user = firebase.auth().currentUser;
    // // this.afAuth.auth.currentUser.delete().then((data) => {
    // user.delete().then(function (data) {
    //   console.log("Success :" + data);
    //   firebase.auth().signOut().then((data) => {
    //     console.log("Success :" + data)
    //     localStorage.clear();
    //     _self.navService.changeNav('');
    //   }, function (error) {
    //     console.log("Exception :" + error);
    //   });
    // }).catch((ex) => {
    //   console.log("Exception :" + ex)
    // });



    // var provider = new firebase.auth.TwitterAuthProvider();
    // provider.setCustomParameters({
    //   prompt: 'select_account'
    // });

    // const userData = JSON.parse(localStorage.getItem("userDetails"));
    // this.afAuth.auth.currentUser.delete().then((data)=>{
    //   console.log("Success :" + data);
    // }).catch((ex) => {

    //   console.log("Exception :" + ex)
    // });

    // firebase.auth().signOut().then((data) => {
    //   console.log("Success :" + data)
    // }, function (error) {
    //   // An error happened.
    //   console.log(error);

    // });

    // this.afAuth.auth.signOut().then(() => {
    // }).catch((ex) => {
    //   console.log("Exception :" + ex)
    // });





  }

  onFBLogout() {

    // var test = true;
    //   localStorage.setItem("isChromeRefreshLogout",JSON.stringify(test));

    // this.authService.signOut().then((data) => {
    //   console.log("Success :" + data);
    // }).catch((ex) => {

    //   console.log("Exception :" + ex)
    // });


    const userData = JSON.parse(localStorage.getItem('userDetails'));
    FB.api(
      '/me/permissions',
      'DELETE',
      { access_token: userData.accessToken },
      (response) => {
        // Here fb should remove the token.
        // response should be "success: true"
        FB.logout(() => {
          // console.log('Success :');
        }, (err) => {
          // console.log('Error logout : ' + err);
        });
      }, (err) => {
        // console.log('Error api : ' + err);
      });

    localStorage.clear();
    this.navService.changeNav('');



    // FB.getLoginStatus(function (response) {
    //   if (response.status === 'connected' || response.status === 'unknown') {
    //     FB.logout(function (response) {
    //       // this part just clears the $_SESSION var
    //       // replace with your own code

    //       console.log('Logged out.' + response);

    //     });
    //   }
    // });


    // localStorage.clear();
    // // this.authService.signOut(true);
    // this.authService.signOut()
    //   .then((data) => {
    //     console.log("Success :" + data);
    //   }).catch((ex) => {
    //    console.log("Exception :" + ex)
    //   });
    // this.navService.changeNav('');
  }
}
